import { CircleCheckIcon } from "lucide-react";

import { useToast } from "@/hooks";

export const useSuccessToast = () => {
  const { toast } = useToast();

  return ({ description }: { description: string }) => {
    toast({
      description: (
        <div className="flex items-center gap-2">
          <CircleCheckIcon className="h-6 w-6 fill-primary-900 text-white" />
          {description}
        </div>
      ),
    });
  };
};
